import React from 'react'
import {FONT_FAMILY_LIST, FONT_SIZE_LIST} from "../common/constants/designer.constant";

const EditFontDetails = ({displayTextItem, handleFontDetailsChanges}) => {

    return (
        <>

            <div className="ml-2 field-label">
                Font
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">
                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field"
                            id="fontSize"
                            name="fontSize"
                            value={displayTextItem?.fontSize}
                            onChange={handleFontDetailsChanges}>
                        </input>
                    </div>
                    <div className="field-container">
                        <select
                            className="input-field"
                            id="fontFamily"
                            name="fontFamily"
                            value={displayTextItem?.fontFamily}
                            onChange={handleFontDetailsChanges}>
                            <option value="">Choose Font Family</option>
                            {FONT_FAMILY_LIST?.map((fontFamily, index) => (
                                <option key={index}
                                        className={`text-family-${displayTextItem?.fontFamily}`}
                                        value={fontFamily.fontKey}>{fontFamily.fontName}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditFontDetails
